import React from 'react';
import { TokenType } from '../../types';
import { TOKEN_INFO } from '../../utils/constants';

interface TokenSelectorProps {
  selectedToken: TokenType;
  onChange: (token: TokenType) => void;
  disabled?: boolean;
}

export const TokenSelector: React.FC<TokenSelectorProps> = ({
  selectedToken,
  onChange,
  disabled = false,
}) => {
  const handleTokenSelect = (token: TokenType) => {
    if (!disabled) {
      onChange(token);
    }
  };

  return (
    <div className="flex gap-2">
      {Object.entries(TOKEN_INFO).map(([token, info]) => (
        <button
          key={token}
          type="button"
          onClick={() => handleTokenSelect(token as TokenType)}
          disabled={disabled}
          className={`
            flex items-center justify-center gap-2 px-4 py-2 rounded-lg border transition-all
            ${selectedToken === token 
              ? 'bg-primary-600 border-primary-500 text-white' 
              : 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'}
            ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          <div className="w-6 h-6 rounded-full bg-gray-800 flex items-center justify-center overflow-hidden">
            {info.icon ? (
              <img src={info.icon} alt={info.name} className="w-5 h-5" />
            ) : (
              <span className="text-xs font-bold">{info.symbol.substring(0, 1)}</span>
            )}
          </div>
          <span className="font-medium">{info.symbol}</span>
        </button>
      ))}
    </div>
  );
};
